import { useEffect, useState } from "react";
import ContentsProps from "../../../interfaceTypes/ContentsProps";

import { requests } from "../../../common/RestAPI";
import { PLATFORM_URL } from "../../../value/Url";
import { useTranslation } from "react-i18next";
import { INode, ILink } from "./Interface";
import { virtualMachineCode, deviceTypeCode, deviceStatusCode } from "./NetworkTopologyData";
import { View } from "react-native";
import NetworkTopologyFilter from "./NetworkTopologyFilter";
import NetworkTopologView from "./NetworkTopologyView";
import ContentBox from "components/base/tamplate/ContentBox";


export default function NetworkTopologyMgmtContainer(props:ContentsProps) {
    const { t } = useTranslation();
    const [sideBarSize, setSideBarSize] = useState(240);
    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);
    const [loadVmYn, setLoadVmYn] = useState(false);
    const [nodes, setNodes] = useState<INode[]>([])
    const [links, setLinks] = useState<ILink[]>([])
    // Filter
    const [showText, setShowText] = useState(false);
    const [showImportantText, setShowImportantText] = useState(true);
    const [deviceStatusList, setDeviceStatusList] = useState<string[]>([]);
    const [filterDeviceStatus, setFilterDeviceStatus] = useState<string[]>([]); // 제외되는 항목
    const [groupList, setGroupList] = useState<string[]>([]);
    const [filterGroup, setFilterGroup] = useState<string[]>([]); // 제외되는 항목
    const [typeList, setTypeList] = useState<string[]>([]);
    const [filterType, setFilterType] = useState<string[]>([]);   // 제외되는 항목
    const [dataCenterList, setDataCenterList] = useState<string[]>([]);
    const [filterDataCenter, setFilterDataCenter] = useState<string[]>([]);   // 제외되는 항목

    useEffect(() => {
        AlertFunction('');
        props.setLoading(true);
        executeLoadData();
    }, []);

    useEffect(()=> {
        function sideBarEventListener(event) {
            const sideBarData = event.detail;
            if("width" in sideBarData) {
                setSideBarSize(sideBarData.width);
            }
        }
    
        window.addEventListener('sideBarEvent', sideBarEventListener);
        return () => {
            window.removeEventListener('sideBarEvent', sideBarEventListener);
        }
    });

    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }

    function getNodeData(data, value=4, dataCenter, upYn, statusCode) {
        return { id: data.id, title: data.title, group: data.group, type: data.type, value:value, dataCenter:dataCenter, upYn, statusCode:statusCode}
    }

    function getLinkData(data, dataCenter) {
        return { source:data.source, target:data.target, title:data.title, dataCenter:dataCenter, width:data.width, speed:data.speed }
    }

    function dataParse(data) {
        const nodes:INode[] = [];
        const links:ILink[] = [];
        const dataCenter:string[] = [];
        const rmsNode = {id: "FornaX", title: "FornaX", group: "FornaX", type: "FornaX", value:1000, dataCenter:"FornaX", upYn:"FornaxX", statusCode:"FornaX"}
        nodes.push(rmsNode);
        data.forEach((d)=>{
            dataCenter.push(d.title)
            nodes.push(getNodeData(d, 100, "", d.extra.up_yn, ""))
            links.push({ source:d.id, target:rmsNode.id, title:rmsNode.title, dataCenter:"", width:1, speed:1 })
            d.childs.forEach((c)=>{
                if(!nodes.some((n)=> n.id === c.id)) {
                    nodes.push(getNodeData(c, 4, d.title, "", c.extra.status_code))
                }
                c.lines.forEach((l)=>{
                    links.push(getLinkData(l, d.title))
                })
            })
        })

        setDataCenterList(otherSort(dataCenter.sort()));
        const statusCode = Array.from(new Set(nodes.map((node)=> node.statusCode)))
        const groups = Array.from(new Set(nodes.map((node)=> node.group)))
        const types = Array.from(new Set(nodes.map((node)=>node.type)))
        
        setGroupList(otherSort(groups.filter(g=> virtualMachineCode.some(d=>d.key === g)).sort()));
        setTypeList(otherSort(types.filter(g=> deviceTypeCode.some(d=>d.key === g)).sort()));
        setDeviceStatusList(otherSort(statusCode.filter(g=> deviceStatusCode.some(d=>d.key === g)).sort()));

        setNodes(nodes);
        setLinks(links);
    }

    function otherSort(array) {
        if(array.some(item => item.toLowerCase() === "other")) {
            const lastIndex = array.length - 1
            const otherIndex = array.findIndex((e) => e.toLowerCase() === "other");
            [array[lastIndex], array[otherIndex]] = [array[otherIndex], array[lastIndex]];
            return array;
        } else {
            return array;
        }
    }


    function executeLoadData(){
        requests.get(PLATFORM_URL.VM_NETWORK + "/topology")
        .then((response) => {
            dataParse(response.data);
            props.setLoading(false)
        })
        .catch((error) => {
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            props.setLoading(false)
        })
    }

    return (
        <ContentBox title={t("MENU_VIRTUAL_LOGICAL_RESOURCE_NETWORK_TOPOLOGY")} subtitle={t("VM_NETWORK_MGMT_SUBTITLE")} infoText={infoText} infoError={infoError}>
            <View style={{height:"100%", flexDirection:"row"}}>
                <NetworkTopologyFilter
                    showText={showText}
                    setShowText={setShowText}
                    showImportantText={showImportantText}
                    setShowImportantText={setShowImportantText}
                    deviceStatusList={deviceStatusList}
                    filterDeviceStatus={filterDeviceStatus}
                    setFilterDeviceStatus={setFilterDeviceStatus}
                    groupList={groupList}
                    filterGroup={filterGroup}
                    setFilterGroup={setFilterGroup}
                    typeList={typeList}
                    filterType={filterType}
                    setFilterType={setFilterType}
                    dataCenterList={dataCenterList}
                    filterDataCenter={filterDataCenter}
                    setFilterDataCenter={setFilterDataCenter}/>
                <NetworkTopologView
                    sideBarSize={sideBarSize}
                    nodes={nodes}
                    links={links}
                    showText={showText}
                    showImportantText={showImportantText}
                    filterDeviceStatus={filterDeviceStatus}
                    filterGroup={filterGroup}
                    filterType={filterType}
                    filterDataCenter={filterDataCenter}/>
            </View>
        </ContentBox>
    )
}